// vue
import { ref } from '@vue/composition-api';

// configs
import drawConfig from '@/vue3/configs/mapbox/drawConfig';

// mapbox
import MapboxDraw from '@mapbox/mapbox-gl-draw';

// libs
import drawRotateMode from '@/vue3/mapbox/drawRotateMode';
import DrawTranslateMode from '@/vue3/mapbox/drawTranslateMode';
import DrawEditMode from '@/vue3/mapbox/drawEditMode';
import MeasureLineStringMode from '@/vue3/mapbox/measureLineStringMode';
import MeasurePolygonMode from '@/vue3/mapbox/measurePolygonMode';
import DrawRectangleMode from '@/vue3/mapbox/drawRectangleMode';
import SurveyLineStringMode from '../mapbox/surveyLineStringMode';
import SurveyPolygonMode from '../mapbox/surveyPolygonMode';
import SurveyPointMode from '../mapbox/surveyPointMode';
import DrawLineStringMode from '../mapbox/drawLineStringMode';
import DrawPolygonMode from '../mapbox/drawPolygonMode';
import SnapLineStringMode from '../mapbox/snapLineStringMode';
import SnapPolygonMode from '../mapbox/snapPolygonMode';
import DrawPointGPS from '../mapbox/drawPointGPS';
import DrawLineGPS from '../mapbox/drawLineGPS';
import DrawPolygonGPS from '../mapbox/drawPolygonGPS';

export const useMapboxDraw = () => {
    const draw = ref(
        new MapboxDraw({
            modes: Object.assign(
                {
                    drawRotateMode: drawRotateMode,
                    DrawTranslateMode: DrawTranslateMode,
                    DrawEditMode: DrawEditMode,
                    MeasureLineStringMode: MeasureLineStringMode,
                    MeasurePolygonMode: MeasurePolygonMode,
                    DrawRectangleMode: DrawRectangleMode,
                    SurveyLineStringMode: SurveyLineStringMode,
                    SurveyPolygonMode: SurveyPolygonMode,
                    SurveyPointMode: SurveyPointMode,
                    DrawLineStringMode: DrawLineStringMode,
                    DrawPolygonMode: DrawPolygonMode,
                    SnapLineStringMode: SnapLineStringMode,
                    SnapPolygonMode: SnapPolygonMode,
                    DrawPointGPS: DrawPointGPS,
                    DrawLineGPS: DrawLineGPS,
                    DrawPolygonGPS: DrawPolygonGPS,
                },
                MapboxDraw.modes,
            ),
            styles: drawConfig.styles,
            displayControlDefault: false,
            userProperties: true,
            snapOptions: {
                snapPx: 15,
                snapToMidPoints: true,
                snapVertexPriorityDistance: 0.0025,
            },
            guides: false,
        }),
    );

    const setDrawMode = (mode: string) => {
        draw.value.changeMode(mode);
    };

    const setDrawSnap = (snapMode: boolean) => {
        draw.value.options.snap = snapMode
    }

    return {
        draw,
        setDrawMode,
        setDrawSnap
    };
};
